import dynamic from "next/dynamic";
const Card = dynamic(() => import("../../../Card"), {
  suspense: true,
});
import { Suspense, FC } from "react";

interface SimilarProps {
  similarProp: any;
}

const SimilarProp: FC<SimilarProps> = ({ similarProp }) => {
  return (
    <div className="mx-auto container">
      <div className="bg-white border flex-1 border-gray-700 flex flex-col p-4 gap-4">
        <h2 className="border-b border-gray-300 text-lg">Similar Properties</h2>
        <Suspense
          fallback={
            <>
              <p>Loading.....</p>
            </>
          }
        >
          {similarProp.length !== 0 ? (
            <div className="grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-2 ">
              {similarProp.map((property: any, index: number) => (
                <Card key={index} property={property} />
              ))}
            </div>
          ) : (
            <>
              <div className="w-full text-center">
                <p className="text-xl">
                  Currently there are no properties similar to this.
                </p>
              </div>
            </>
          )}
        </Suspense>
      </div>
    </div>
  );
};

export default SimilarProp;
